import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useTable } from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import Swal from 'sweetalert2'; // Import SweetAlert2
import '../styles/noPrint.css'
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import ApproverModal from './ApproverModal';

const PreviewStatusTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const email = localStorage.getItem('email'); // Retrieve email from localStorage
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const [draftData, setDraftData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const pin = localStorage.getItem('pin');
  const addContent = "Below Mentioned Inventory's status to be transfered after approval of this voucher.";
  const addContentApproved = "Below Mentioned Inventory's status has been transfered after approval of this voucher.";

  let id = searchParams.get('draftId') ? searchParams.get('draftId') : location.state?.id
  const token = localStorage.getItem('token');
  const personId = searchParams.get('personId'); // Get personId from search params
  const [personOptions, setPersonOptions] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [draftId, setDraftID] = useState(null);
  const [departmentForModal, setDepartmentForModal] = useState(null);
  useEffect(() => {
    if (!token) {
      // Redirect to login page with additional data
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=statusTransfer`
      );
      return;
    }

    const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
        setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
      }
    };

    const fetchDraftData = async () => {
      if (id) {
        try {
          setLoading(true);
          const response = await apiClient.get(`${SERVER_BASE}/getStatusTransfer/${id}`);

          setDraftData(response.data);
        } catch (err) {
          setError(err.response?.data?.message || 'Error fetching draft data');
        } finally {
          setLoading(false);
        }
      }
    };
    const fetchPersons = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        });
        setPersonOptions(
          response.data.map((person) => ({
            value: person.id,
            label: `${person.firstName} ${person.lastName} - ${person.contactNo}`, // Assuming 'firstName' and 'lastName' are available
            mobileNo: person.contactNo,
            badgeId: person.badgeId,
            position: person.position,
            sewadarOf: person.sewadarOf
          }))
        );

      } catch (error) {
        console.error('Error fetching persons for approval:', error);
      }
    };
    fetchPersons();
    fetchProfileDetails();
    fetchDraftData();
  }, [token, navigate, email, searchParams]);

  const handleApprove = () => {
    // SweetAlert2 for PIN input
    Swal.fire({
      title: 'Enter your PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter your PIN.';
        }
        if (value !== pin) {
          return 'Invalid PIN. Please try again.';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with the approval if PIN matches
        const approvedBy = name;
        const approvedByBadge = badgeId;

        // Send the approval request to the backend
        apiClient.post(`${SERVER_BASE}/approveStatusTransfer`, {
          id,
          approvedBy,
          approvedByBadge,
        })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Voucher Approved!',
              text: 'The voucher has been approved successfully.',
              confirmButtonText: 'OK',
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Failed to approve the voucher: ${err.response?.data?.message || err.message}`,
              confirmButtonText: 'OK',
            });
          });
      }
      // fetchDraftData();
    });
  };
  const handleSendForApproval = () => {
    if (!token) {
      window.location.href = "/";
      return;
    }

    setDraftID(id);
    setDepartmentForModal(draftData.department);
    setModalShow(true);
  };

  const getFilteredOptions = () => {
    return personOptions.filter(
      person =>
        person.position === "Authorized Person" ||
        person.sewadarOf === departmentForModal
    );
  };

  // Handle Modal Submit (send for approval)
  const handleModalSubmit = async (personId) => {
  
    const selectedPerson = personOptions.find(
      (person) => String(person.value) === String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;
    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${draftId}`,
        { personId ,type:'statusTransfer'},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const baseLink = `https://rs.iosystem.in/previewTransferStatus?id=${draftId}`;
      const fullLink = `${baseLink}&draftId=${draftId}&personId=${personId}&type=statusTransfer`;
      const whatsappLink = `https://wa.me/${mobileNo}?text=${encodeURIComponent(
        `Please Approve this Status Transfer: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");
  
      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };
  const closeModal = () => {
    setModalShow(false); // Close the modal
  };
  const columns = React.useMemo(
    () => [
      {
        Header: 'Item Name',
        accessor: 'item',
      },
      {
        Header: 'From',
        accessor: 'fromStatus',
      },
      {
        Header: 'Quantity',
        accessor: 'transferQty',
        Cell: ({ value }) =>
          Number(value) % 1 === 0 ? parseInt(value) : parseFloat(value).toFixed(2),
      },
      {
        Header: 'UOM',
        accessor: 'uom',
      },
      {
        Header: 'To',
        accessor: 'toStatus',
      },
    ],
    []
  );

  const tableInstance = useTable({
    columns,
    data: draftData?.inventory || [],
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  if (!token) {
    return null; // Return nothing if the user is redirected
  }

  if (loading) {
    return <p className="text-center mt-4">Loading...</p>;
  }

  if (error) {
    return <p className="text-center text-danger mt-4">Error: {error}</p>;
  }

  return (
    <div className="mt-3 d-flex flex-column align-items-center">

      <div className="bg-white p-4 border border-dark">
        <h3 className="text-center mb-4">Radha Soami Satsang Beas, Bilwa</h3>
        {draftData ? (
          <div>
            <div className="d-flex justify-content-between no-print mb-3">
              {/* Left side - Back button */}
              <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                Back
              </button>

              {/* Right side - Approval buttons */}
              <div>
                {profileDetails &&
                  String(profileDetails.id) !== String(personId) &&
                  String(profileDetails.id) !== String(draftData?.authorizedPersonId) &&
                  draftData.status !== 'Approved' && (
                    <button className="btn btn-secondary me-2" onClick={handleSendForApproval}>
                      <FontAwesomeIcon icon={faPaperPlane} /> Send for Approval
                    </button>
                  )}

                {profileDetails &&
                  (String(profileDetails.id) === String(personId) ||
                    String(profileDetails.id) === String(draftData?.authorizedPersonId)) &&
                  draftData.status !== 'Approved' && (
                    <button className="btn btn-success" onClick={handleApprove}>
                      Approve
                    </button>
                  )}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <p><strong>Date:</strong> {moment(draftData?.date).format('DD-MMM-YY')}</p>
            </div>
            <div className="d-flex justify-content-between">
              <p><strong>Department:</strong> {draftData?.department}</p>
              <p><strong>Location:</strong> {draftData?.location}</p>
            </div>
            <p><strong>{(draftData?.status === 'Approved' ? addContentApproved : addContent)}</strong></p>
            <table {...getTableProps()} className="table table-bordered table-striped mt-3">
              <thead className="thead-light">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="row">
              <div className="col-md-6">
                <p className="mb-1"><strong>Prepared By</strong></p>
                <p className="mb-1">{draftData?.createdBy} - {draftData?.createdByBadge}</p>
                <p className="mb-1"><strong>Aproved By</strong></p>
                <p className="mb-1">{draftData?.approvedBy} - {draftData?.approvedByBadge}</p>
              </div>
              <div className="col-md-6 text-end">
                <p className="mb-1"><strong>Authorized Signatory</strong></p>
              </div>
            </div>
          </div>
        ) : (
          <p className="text-center">No draft data available.</p>
        )}
      </div>
      <ApproverModal
        show={modalShow}
        title="Send for Approval"
        options={getFilteredOptions()}
        close={closeModal} // Pass close function
        onSubmit={handleModalSubmit}
      />
    </div>
  );
};

export default PreviewStatusTransfer;
